import React from "react"

interface Props extends React.ComponentPropsWithoutRef<"svg"> {
    size?: number | string
    style?: React.CSSProperties
    color?: string
    className?: string
}

export function FacebookFarFAIcon({ size = 16, color, style, className, ...others }: Props) {
    return (
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="facebook"
            className={`svg-inline--fa fa-facebook fa-w-10 fa-fw ${className}`}
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            color={color}
            style={{ width: size, height: size, ...style }}
            {...others}
        >
            <path
                fill="currentColor"
                d="M16 8C16 12.0938 12.9375 15.4688 8.96875 15.9375V10.4375H11.125L11.5938 8H8.96875V7.125C8.96875 5.84375 9.46875 5.34375 10.7812 5.34375C11.1875 5.34375 11.5312 5.34375 11.7188 5.375V3.15625C11.3438 3.0625 10.4688 2.96875 9.96875 2.96875C7.3125 2.96875 6.0625 4.21875 6.0625 6.9375V8H4.40625V10.4375H6.0625V15.7812C2.59375 14.9062 0 11.75 0 8C0 3.59375 3.59375 0 8 0C12.4062 0 16 3.59375 16 8Z"
            />
        </svg>
    )
}
